import { ChangeDetectorRef, Component } from '@angular/core';
import { ClientPicklistComponent } from '../client-picklist/client-picklist.component';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription, concat, of, filter, distinctUntilChanged, debounceTime, tap, switchMap, catchError } from 'rxjs';
import { ClientBaseModel } from 'src/app/core/models/members/client/client-base-model';
import { ClientModel } from 'src/app/core/models/members/client/client.model';
import { SearchResultModel } from 'src/app/core/models/query/search-result-model';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { ClientModalService } from 'src/app/core/services/modal-services/client-modal.service';
import { OpenModalService } from 'src/app/core/services/modal-services/open-modal.service';
import { PdfViewerModalService } from 'src/app/core/services/modal-services/pdf-viewer-modal.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { ClientListService } from 'src/app/core/services/list-services/client-list.service';
import { ClientViewModuleService } from 'src/app/core/services/modal-services/client-view-module.service';
import { InviteModalService } from 'src/app/core/services/modal-services/invite-modal.service';
import { ClientSearchModel } from 'src/app/core/models/members/client/client-search-model';
import { TaskModalService } from 'src/app/core/services/modal-services/task-modal.service';
import { TableConfigService } from 'src/app/core/services/table-config.service';

@Component({
  selector: 'app-client-list-dropdown',
  templateUrl: './client-list-dropdown.component.html',
  styleUrls: ['./client-list-dropdown.component.scss']
})
export class ClientListDropdownComponent extends ClientPicklistComponent {

  selectedModelsArray: any[] = [];

  constructor(
    protected myClientModalService: ClientModalService,
    private myClientPicklistService: ClientViewModuleService,
    protected override taskModalService: TaskModalService,
    protected override changeDetectorRef: ChangeDetectorRef,
    protected override clientListService: ClientListService,
    protected override myInviteModalService: InviteModalService,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override tableConfigService: TableConfigService,
    protected override myFileApiService: MyfileApiService,
    protected override sanitizer: DomSanitizer,
    protected override pdfModalService: PdfViewerModalService,
    protected override authMyFileService: AuthMyfileService,
    protected override openModalService: OpenModalService,
  ) {
    super(changeDetectorRef, taskModalService, myInviteModalService, clientListService, toasterNotificationService, tableConfigService,myFileApiService, sanitizer, openModalService, pdfModalService, authMyFileService);
  }

  override ngOnInit(): void {

    this.listItemsObservable = this.clientListService.resultItems$;
    this.total = this.clientListService.total$;
    this.isLoading = this.clientListService.loading$;

    const subscr = this.isLoading.subscribe(result => {
      if (result) {
        this.serviceData.loadingValue = true;
      } else {
        this.serviceData.loadingValue = false;
      }
    });
    this.unsubscribe.push(subscr);

    const subscr2 = this.listItemsObservable.subscribe(result => {
      this.listItems = Object.assign([], result);
    });
    this.unsubscribe.push(subscr2);

    this.changeDetectorRef.detectChanges();

    this.loadModelsInDropDownList();
    if (this.referenceModel.id) {
      this.selectedModelsArray.push(this.referenceModel)
    }
    if (typeof(this.referenceModel) == "string") {

      String(this.referenceModel).split(`,`).forEach((id:string)=>{
        this.myFileApiService.getClient(id).subscribe((clientModel)=>{
          if(clientModel){
            this.selectedModelsArray.push(clientModel);
          }
        });
      })
    }

  }

  getDropdownName(item: any) {
    if (item.firstName && item.firstName != '' && item.companyName && item.companyName != '') {
      return `${item.fullName} - ${item.companyName}`;
    } else {
      return `${item.fullName}`;
    }
  }

  /**
   * Opens a new Modal.
   * @param modal used for a modal type using enum in the model-clientListService.clientListServices.ts
   * @param model a model which will be passed to the modal
   */
  openPicklistModal(model: any) {
    if (this.disabled !== true) {
      this.myClientPicklistService.openModal(model);
      var sub: Subscription = this.myClientPicklistService.modelChanged.subscribe((result: ClientModel) => {
        if (result) {
          this.model = new ClientModel();
          this.model = { ...this.model, ...result };
          this.legacyModelCheckAndSet();
          this.referenceModel = this.model;
          this.selectedModelsArray = [];
          this.selectedModelsArray.push(result);
          this.referenceModelChange.emit(this.referenceModel);
        }
        this.submitted = false;
        sub.unsubscribe();
      });
    }
  }

  openModalNewClientDropDownSearch() {
    if (this.disabled !== true) {
      this.myClientModalService.openModal();
      var sub: Subscription = this.myClientModalService.modelChanged.subscribe((client: any) => {
        if (client.id) {
          this.model = client;
          this.legacyModelCheckAndSet();
          this.referenceModel = this.model;
          this.selectedModelsArray = [];
          this.selectedModelsArray.push(this.model);
          this.referenceModelChange.emit(this.referenceModel);
        }
        sub.unsubscribe();
      })
    }
  }

  loadModelsInDropDownList() {
    this.listItems$ = concat(
      of([]), // default items
      this.listItemsInput$.pipe(
        filter(res => {
          if (res !== null && res.length > this.minLengthTerm) {
            this.searchTermLength = res.length;
          } else {
            this.searchTermLength = 0;
          }
          return res !== null && res.length > this.minLengthTerm;
        }),
        distinctUntilChanged(),
        debounceTime(800),
        tap(() => this.listItemsLoading = true),
        switchMap(term => {

          var search = new ClientSearchModel();
          search.searchTerm = term;

          var clients = this.myFileApiService.getClients(search).pipe(

            switchMap((clientSearchResult: SearchResultModel<ClientBaseModel>|undefined) => 
              //returns the entire base entity for use with ng-templates on the ng-select  
              of(clientSearchResult?.items.map((clientBaseModel: ClientBaseModel) => clientBaseModel))
            ),

            catchError(() => of([])), // empty list on error

            tap(() => this.listItemsLoading = false)
          );

          return clients;
        })
      )
    );
  }

  arrayCleared() {
    this.referenceModel = new ClientModel();
    this.referenceModelChange.emit(this.referenceModel);
  }

}
